import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {CommonService} from '../../common/controller/common.service';




import {ApiMessageService} from '../../core/api-message.service';
import {Router} from '@angular/router';
import {JsonBaseBuilder} from '../../common/builder/json-base-builder';
import {PersonaEntitaOrganizzativa} from './personaentitaorganizzativa.model';
import {ConfigService} from '../../core/config.service';
import {Table} from '../../common/model/table.model';
import {MODULE_ANAGRAFICA} from '../../app-routing.module';

@Injectable()
export class PersonaEntitaOrganizzativaService extends CommonService<PersonaEntitaOrganizzativa> {

  public static ROUTE = 'personaentitaorganizzativa';

  public constructor(protected httpClient: HttpClient,
                     protected apiMessageService: ApiMessageService,
                     protected router: Router,
                     protected configService: ConfigService) {
    super(httpClient, apiMessageService, router, configService);
  }

  public buildInstance(json: any): PersonaEntitaOrganizzativa {
    return JsonBaseBuilder.jsonToPersonaEntitaOrganizzativa(json);
  }

  public getApiService(): string {
    return ConfigService.ACE;
  }

  public getModule(): string {
    return MODULE_ANAGRAFICA;
  }

  public getRoute(): string {
    return PersonaEntitaOrganizzativaService.ROUTE;
  }

  public getTable(items: PersonaEntitaOrganizzativa[]): Table {
    return Table.buildBaseTable(PersonaEntitaOrganizzativa.getTableKeys(), items);
  }

}
